module.exports = __webpack_public_path__ + "static/media/gcp.9691a2ff.svg";